<template>
    <div class="d-flex align-items-stretch">
        <div v-if="hasFunction">
            <div
                v-bind:class="textOperatorClassName"
                class="align-self-center">
                {{ functionDisplay }}
            </div>
        </div>
        <parens
            v-if="showParens"
            left />
        <div class="d-flex align-items-center">
            {{ display }}
        </div>
        <parens v-if="showParens" />
    </div>
</template>
<script>
    import displayReference from "./_displayReferenceMixin.js";
    import base from "./_baseExpression.vue";
    import { EXPRESSION_TYPES } from "Formula/expressionTypes.js";

    export default {
        extends: base,
        mixins: [displayReference],
        props: {
            functionName: { type: String, required: false, default: null }
        },
        computed: {
            hasFunction() {
                return Boolean(this.functionName);
            },
            functionDisplay() {
                if (!this.hasFunction) {
                    return null;
                }
                return this.functionName;
            },
            display() {
                const displayText = this.getReferenceDisplay();
                if (
                    this.expression.Type === EXPRESSION_TYPES.ProjectNumberReference &&
                    !this.formulaControl.inToolboxMode
                ) {
                    return `{${displayText}}`;
                }
                return displayText;
            },
            showParens() {
                if (this.expression.Type === EXPRESSION_TYPES.ProjectNumberReference) {
                    return (
                        this.formulaControl.inToolboxMode || (this.formulaControl.inEditMode && this.path.length === 1)
                    );
                }
                //Show Parens only Data field Definition is not set.
                return this.hasFunction || this.expression.PublicDataFieldDefinitionId === null;
            }
        }
    };
</script>
